/**
 * Engraving Feature Handler
 * Handles the engraving toggle, style selection, and line item property submission
 */
(function() {
  'use strict';

  function initEngraving() {
    const engravingContainer = document.querySelector('.product-form__engraving');
    if (!engravingContainer) return;

    const toggle = engravingContainer.querySelector('[data-engraving-toggle]');
    const fields = engravingContainer.querySelector('[data-engraving-fields]');
    const styleButtons = engravingContainer.querySelectorAll('[data-engraving-style]');
    const styleLabels = engravingContainer.querySelectorAll('.engraving-style-button');
    const messageInput = engravingContainer.querySelector('[data-engraving-message]');
    const stylePropertyInput = engravingContainer.querySelector('[data-engraving-property-style]');
    const messagePropertyInput = engravingContainer.querySelector('[data-engraving-property-message]');
    
    if (!stylePropertyInput || !messagePropertyInput || !toggle || !fields || !messageInput) return;
    
    // Get the product form - find it using the form attribute from hidden inputs or search nearby
    let productForm = null;
    const formId = stylePropertyInput.getAttribute('form');
    if (formId) {
      productForm = document.getElementById(formId);
    }
    // Fallback: search for form with is="product-form" in the parent container
    if (!productForm) {
      const parentContainer = engravingContainer.closest('.product-form') || engravingContainer.parentElement;
      productForm = parentContainer?.querySelector('form[is="product-form"]');
    }
    // Final fallback: search document
    if (!productForm) {
      productForm = document.querySelector('form[is="product-form"]');
    }
    
    if (!productForm) return;

    // Remove existing error message if present
    const existingError = engravingContainer.querySelector('.engraving-error-message');
    if (existingError) existingError.remove();

    // Initialize: Hide fields by default if checkbox is not checked
    if (!toggle.checked) {
      fields.style.display = 'none';
    }

    // Toggle fields visibility and handle values
    toggle.addEventListener('change', function() {
      if (this.checked) {
        // Show fields when checked
        fields.style.display = 'block';
        // Remove error styling when checkbox is checked
        messageInput.classList.remove('input__field--error');
        const errorMsg = engravingContainer.querySelector('.engraving-error-message');
        if (errorMsg) errorMsg.remove();
      } else {
        // Hide fields when unchecked
        fields.style.display = 'none';
        
        // Reset style to Block (default)
        const blockRadio = engravingContainer.querySelector('[value="Block"]');
        if (blockRadio) {
          blockRadio.checked = true;
          styleLabels.forEach(label => label.classList.remove('engraving-style-button--active'));
          const blockLabel = engravingContainer.querySelector('label[for="' + blockRadio.id + '"]');
          if (blockLabel) blockLabel.classList.add('engraving-style-button--active');
        }
        // Clear message
        messageInput.value = '';
        
        // Clear hidden property inputs
        stylePropertyInput.value = '';
        messagePropertyInput.value = '';
        
        // Remove any error message
        const errorMsg = engravingContainer.querySelector('.engraving-error-message');
        if (errorMsg) errorMsg.remove();
        messageInput.classList.remove('input__field--error');
      }
    });

    // Handle style button selection (visual update and property update)
    styleButtons.forEach((radio, index) => {
      radio.addEventListener('change', function() {
        styleLabels.forEach(label => label.classList.remove('engraving-style-button--active'));
        if (this.checked) {
          styleLabels[index].classList.add('engraving-style-button--active');
          // Update hidden property input if checkbox is checked
          if (toggle.checked) {
            stylePropertyInput.value = this.value;
          }
        }
      });
    });

    // Update message property when user types (if checkbox is checked)
    messageInput.addEventListener('input', function() {
      if (this.value.trim().length > 0) {
        this.classList.remove('input__field--error');
        const errorMsg = engravingContainer.querySelector('.engraving-error-message');
        if (errorMsg) errorMsg.remove();
        
        // Update hidden property input if checkbox is checked
        if (toggle.checked) {
          messagePropertyInput.value = this.value.trim();
        }
      } else {
        messagePropertyInput.value = '';
      }
    });

    // Intercept form submission to validate and update line item properties
    // Use capture phase to ensure our handler runs first
    productForm.addEventListener('submit', function(e) {
      // Remove existing error message
      const existingError = engravingContainer.querySelector('.engraving-error-message');
      if (existingError) existingError.remove();
      messageInput.classList.remove('input__field--error');

      // Validate: if checkbox is checked, message must have at least 1 character
      if (toggle.checked) {
        if (messageInput.value.trim().length === 0) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          // Show error message
          const errorMsg = document.createElement('div');
          errorMsg.className = 'engraving-error-message';
          errorMsg.style.color = '#d32f2f';
          errorMsg.style.fontSize = '0.875rem';
          errorMsg.style.marginTop = '0.5rem';
          errorMsg.textContent = 'Please enter a message (at least 1 character)';
          messageInput.parentElement.appendChild(errorMsg);
          messageInput.classList.add('input__field--error');
          
          // Clear property inputs
          stylePropertyInput.value = '';
          messagePropertyInput.value = '';
          
          // Focus on message input
          messageInput.focus();
          return false;
        }

        // Update property inputs if checkbox is checked AND message has value
        const selectedStyle = engravingContainer.querySelector('[data-engraving-style]:checked');
        
        if (selectedStyle) {
          stylePropertyInput.value = selectedStyle.value;
        }
        messagePropertyInput.value = messageInput.value.trim();
      } else {
        // Clear property inputs if checkbox is not checked
        stylePropertyInput.value = '';
        messagePropertyInput.value = '';
      }
    }, true); // Use capture phase
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEngraving);
  } else {
    initEngraving();
  }

  // Also initialize when sections are loaded in theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initEngraving);
  }
})();

